import { PAGE_LEVEL } from '@/constants';

/**
 * 通讯录模块路由
 */
export default {
  meta: { localeModules: ['contacts', 'systemSetting'] },
  // 通讯录
  path: '/addressBook',
  redirect: '/addressBook/internalContacts',
  children: [
    {
      // 内部联系人
      path: 'internalContacts',
      name: 'internalContacts',
      component: () => import(/* webpackChunkName: 'address-book' */ '@/pages/addressBook/index.vue'),
      meta: {
        name: 'routers.address_book_internal_contacts',
        componentName: 'AddressBookIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        hideSubNav: true
      }
    },
    {
      // 券商研究所
      path: 'securitiesDealer',
      name: 'securitiesDealer',
      component: () => import(/* webpackChunkName: 'address-book' */ '@/pages/addressBook/index.vue'),
      meta: {
        name: 'routers.address_book_securities_dealer',
        componentName: 'AddressBookIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        hideSubNav: true
      }
    }
  ]
};
